import React from 'react';
import classnames from 'classnames';
import ItemWithTooltip from '@minecraft.item-with-tooltip';
import { BodyText, PaywallButton, PrimaryButton } from '@minecraft.atoms';
import { PlanType } from '../usePlans';
import { BillingCodes } from '../enums/plans';

export const PlanButton: React.FC<{
  plan: PlanType;
  goToNextStep: (plan: PlanType) => void;
  t: (key: string, params?: Record<string, unknown>) => string;
  uniqueId?: string;
  className?: string;
}> = ({ plan, goToNextStep, t, className = '', uniqueId = '' }) => {
  if (plan?.cta) {
    const isDisabled = (plan.isCurrent && !plan.canRenew) || plan.isUpgradeDisabled;
    const classes = classnames(
      {
        [`cn_gradient-bg-${plan.gradientColor}`]: !isDisabled && plan.gradientColor,
      },
      className
    );
    const isFreePlan = plan.billingCode === BillingCodes.registration;

    const button = !isFreePlan ? (
      <PaywallButton
        color={plan.isTrialPeriodEnabled ? `${plan.temperature}Trial` : plan.temperature}
        className={classes}
        fixedWidth
        startIcon={plan.iconName ? { name: 'check-circle', justify: 'end' } : null}
        onClick={() => goToNextStep(plan)}
        disabled={isDisabled}
        variant={plan.isSecondary ? 'secondary' : undefined}
        data-unique-id={uniqueId}
        label={{ name: plan?.cta, justify: 'start' }}
      />
    ) : (
      <PrimaryButton
        label={plan?.cta}
        variant="secondary"
        onClick={() => goToNextStep(plan)}
        disabled={isDisabled}
        data-unique-id={uniqueId}
        fixedWidth
      />
    );

    if (plan.isUpgradeDisabled) {
      return (
        <ItemWithTooltip
          tooltipPlacement="bottom"
          id="tooltip-pawall-plan-trial"
          className="cn_w-full"
          tooltipContent={
            <BodyText color="inverted" align="center" className="cn_max-w-md cn_w-full cn_atom_p-2">
              {t('common:paywall.plan.trial.tooltip')}
            </BodyText>
          }
          key="paywall-plan-trial-tooltip"
        >
          {button}
        </ItemWithTooltip>
      );
    }

    return button;
  }

  return null;
};
